import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API_BASE_URL = "https://bluewaterdubai.websiteseoonline.com";
const BLOG_LIMIT = 6;
const FALLBACK_IMAGE = "assets/img/blog/blog_1_1.jpg";

function buildApiUrl(pathname) {
  const baseUrl = (process.env.REACT_APP_API_BASE_URL || API_BASE_URL).replace(/\/$/, "");
  return `${baseUrl}${pathname}`;
}

function imageWithVariant(image, variant, fallback) {
  return image ? `${image}/${variant}` : fallback;
}

function blogUrl(blog) {
  return blog.url || "/blog";
}

function blogDate(blog) {
  return blog.date || "";
}

function LatestInsights() {
  const [blogs, setBlogs] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const controller = new AbortController();

    async function loadBlogs() {
      setStatus("loading");

      try {
        const response = await fetch(buildApiUrl("/api/blogsapi.ashx"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            typ: "Latest News",
            home: "Yes",
            id: "0",
          }),
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error("Unable to load latest insights");
        }

        const payload = await response.json();
        setBlogs(payload.result === 1 && Array.isArray(payload.data) ? payload.data.slice(0, BLOG_LIMIT) : []);
        setStatus("ready");
      } catch (err) {
        if (err.name !== "AbortError") {
          setBlogs([]);
          setStatus("error");
        }
      }
    }

    loadBlogs();

    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (status !== "ready" || !blogs.length) {
      return undefined;
    }

    let swiper = null;
    let retryTimer = null;
    let cancelled = false;

    function initSlider() {
      const slider = document.getElementById("latestInsightsSlider");

      if (cancelled || !slider) {
        return;
      }

      if (!window.Swiper) {
        retryTimer = window.setTimeout(initSlider, 200);
        return;
      }

      if (slider.swiper) {
        slider.swiper.update();
        return;
      }

      swiper = new window.Swiper(slider, {
        autoHeight: true,
        spaceBetween: 24,
        navigation: {
          nextEl: "#latestInsightsNext",
          prevEl: "#latestInsightsPrev",
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          576: { slidesPerView: 1 },
          768: { slidesPerView: 1 },
          992: { slidesPerView: 2 },
          1200: { slidesPerView: 2 },
          1300: { slidesPerView: 3 },
        },
      });
    }

    initSlider();

    return () => {
      cancelled = true;
      if (retryTimer) {
        window.clearTimeout(retryTimer);
      }
      if (swiper) {
        swiper.destroy(true, true);
      }
    };
  }, [blogs, status]);

  return (
    <section className="space overflow-hidden" style={{ background: "#fff" }} id="blog-sec">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7">
            <div className="title-area text-center">
              <h2 className="sec-title fadeinup wow" data-wow-duration="1.5s" data-wow-delay="0.3s">
                latest Insights
              </h2>
            </div>
          </div>
        </div>
        {status === "loading" && <div className="text-center">Loading latest insights...</div>}
        {status === "error" && <div className="text-center">Unable to load latest insights.</div>}
        {status === "ready" && blogs.length === 0 && <div className="text-center">No latest insights found.</div>}
        {status === "ready" && blogs.length > 0 && (
          <div className="slider-area">
            <div className="swiper react-managed-slider has-shadow" id="latestInsightsSlider">
              <div className="swiper-wrapper">
                {blogs.map((blog) => (
                  <div className="swiper-slide" key={blog.id || blog.title}>
                    <div className="blog-card style-2">
                      <div className="blog-img">
                        <Link to={blogUrl(blog)}>
                          <img src={imageWithVariant(blog.Image, "w=410,sharpen=1", FALLBACK_IMAGE)} alt={blog.title || "Insight"} />
                        </Link>
                        <div className="date">
                          <Link to="/blog">
                            <span>{blogDate(blog)}</span>
                          </Link>
                        </div>
                      </div>
                      <div className="blog-content">
                        <div className="blog-meta">
                          <Link to="/blog">
                            <i className="fa-solid fa-user" />
                            Blue Water
                          </Link>
                          <Link to={blogUrl(blog)}>
                            <i className="fa-solid fa-comments" />
                            Insights
                          </Link>
                        </div>
                        <h3 className="box-title">
                          <Link to={blogUrl(blog)}>{blog.title || "Latest Insight"}</Link>
                        </h3>
                        <Link to={blogUrl(blog)} className="th-btn pill style3">
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <button id="latestInsightsPrev" className="slider-arrow slider-prev" type="button">
              <i className="far fa-arrow-left" />
            </button>
            <button id="latestInsightsNext" className="slider-arrow slider-next" type="button">
              <i className="far fa-arrow-right" />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default LatestInsights;
